import { render, staticRenderFns } from "./SimuladorModal.vue?vue&type=template&id=55276512&scoped=true"
import script from "./SimuladorModal.vue?vue&type=script&lang=js"
export * from "./SimuladorModal.vue?vue&type=script&lang=js"
import style0 from "./SimuladorModal.vue?vue&type=style&index=0&id=55276512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55276512",
  null
  
)

export default component.exports